import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";
import { Button } from "@athena/ui";
import type { ClientRecord } from "../helpers/client";
import { useSendWelcomeEmails } from "../helpers/useSendWelcomeEmails";

interface SendWelcomeEmailProps {
    client: ClientRecord;
}

/**
 * "Send welcome email" on a client's profile (ATH-244): how to sign in to the account their import
 * made, sent when the coordinator chooses. "Resend" once one has gone. Not offered when the API says
 * one cannot go — they have signed in, have no account, are not to be contacted or unsubscribed.
 * One email to the person on screen, so it sends on the click; a send to more than one asks first.
 */
export function SendWelcomeEmail({ client }: SendWelcomeEmailProps) {
    const { t } = useTranslation();
    const { sendWelcomeEmails, sending } = useSendWelcomeEmails();
    if (client.welcomeEmailBlocker) return null;
    return (
        <Button
            variant="outline"
            className="w-auto"
            leftIcon={<Mail className="h-4 w-4" />}
            disabled={sending}
            onClick={() => void sendWelcomeEmails([client.id])}
        >
            {sending
                ? t("admin.alumni.welcome.sending")
                : client.welcomeEmailSentAt
                  ? t("admin.alumni.welcome.resend")
                  : t("admin.alumni.welcome.send")}
        </Button>
    );
}
